import * as React from "react";
import { debounce } from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton } from "@mui/material";

export default function Search({ setPage, setSearchKey }) {
  const handleSearchDebounce = React.useMemo(
    () =>
      debounce((val) => {
        setPage((prev) => ({
          ...prev,
          page: 1,
        }));
        setSearchKey(val);
      }, 300),
    [setPage, setSearchKey]
  );

  const handleSearchChange = (e) => {
    if (e.key === "Enter" || e.code === "Enter") {
      e.preventDefault();
    }
    handleSearchDebounce(e.target.value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: "15px 18px",
        display: "flex",
        alignItems: "center",
        width: "inherit",
        height: "50px",
        borderRadius: "15px",
        justifyContent: "space-between",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      }}
    >
      <InputBase
        fullWidth
        placeholder="Search"
        onChange={handleSearchChange}
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            mixBlendMode: "normal",
            opacity: 0.4,
          },
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "rgba(128, 128, 128, 0.7)" }} />
      </IconButton>
    </Paper>
  );
}
